import {
  PARTICIPANT_TYPES,
  IDENTITY_REQUEST_TYPES
} from '@/constants/business'

const organizationMixin = {
  methods: {
    getRequestTypeByOrganization: function (participantType) {
      return !participantType || participantType === PARTICIPANT_TYPES.PARTICIPANT
        ? IDENTITY_REQUEST_TYPES.PARTICIPANT_LEGAL_ORGANIZATION
        : IDENTITY_REQUEST_TYPES.LEGAL_ORGANIZATION
    }
  }
}

export default organizationMixin
